<script>
    import {onMount} from "svelte";
    export let value;

    function addRow() {
        value = [...value, {}];
    }

    function deleteRow(row) {
        value = value.filter((r) => r !== row);
    }

    onMount(() => {
        if (!value) {
            addRow();
        }
    });
</script>

<table class="table is-fullwidth is-bordered is-striped">
    <thead>
        <tr>
            <th>Cells</th>
            <th>Value</th>
            <th>Cell Background</th>
            <th>Font Color</th>
            <th>Delete</th>
        </tr>
    </thead>
    <tfoot>
        <tr>
            <td colspan="5">
                <span class="buttons is-right">
                    <span class="button" on:click={addRow}>Add Row</span>
                </span>
            </td>
        </tr>
    </tfoot>
    <tbody>
    {#each value as row}
        <tr>
            <td>
                <input class="input" bind:value={row.cells} required="required">
            </td>
            <td>
                <input class="input" bind:value={row.value} required="required">
            </td>
            <td>
                <input class="input color" type="color" bind:value={row.bgColor}>
                {#if row.bgColor}
                    <span class="delete" on:click={() => row.bgColor = undefined}></span>
                {/if}
            </td>
            <td>
                <input class="input color" type="color" bind:value={row.color}>
                {#if row.color}
                    <span class="delete" on:click={() => row.color = undefined}></span>
                {/if}
            </td>
            <td>
                <span class="button is Danger" on:click={deleteRow(row)}>Delete Row</span>
            </td>
        </tr>
    {/each}
    </tbody>
</table>

<style>
    .color {
        width: 75px;
    }
</style>